/**
 * Theme's main js file
 * May handle main logic
 */
(function($, d, w) {

	var $w = $(w);
	var $d = $(d);
	var $html = $('html');
	var html = $html.get(0);
	var $header;
	var $menuItems;
	var $menuLine;
	var darkRows = [];
	var footerOffsetTop = 0;
	var documentHeight = 0;

	$w.on(w.ZP_READY, onReady);
	$w.on(w.ZP_LOAD, onLoad);
	$w.on(w.ZP_SCROLL, onScroll);
	$w.on(w.ZP_RESIZE, onResize);
	$w.on(w.ZP_LIGHTBOX_INIT, onLightboxInit);
	$w.on(w.ZP_AOS_INIT, onAosInit);

	function onReady() {
		$html.addClass("zp-ready");

		$w.paroller();

		darkRows = $d.get(0).getElementsByClassName('am-light');

		$header = $('#zp-header');

		var $topNavInner = $header.find("#zp-topnav > *");
		$topNavInner.append('<div id="zp-topnav-line"></div>');

		$menuLine = $topNavInner.find("#zp-topnav-line");

		$("*:not([data-toggle='tooltip'])").renameAttr('title', 'zp-title').renameAttr('alt', 'zp-alt');


		$("#zp-mobilenav .zp-item.current-page-ancestor, " +
			"#zp-mobilenav .zp-item.current-page-ancestor, " +
			"#zp-mobilenav .zp-item.current-menu-ancestor, " +
			"#zp-mobilenav .zp-item.current-zp-item," +
			"#zp-mobilenav .zp-item.current_menu_parent," +
			"#zp-mobilenav .zp-item.current-menu-parent," +
			"#zp-mobilenav .zp-item.current-page-parent," +
			"#zp-mobilenav .zp-item.current_page_parent," +
			"#zp-mobilenav .zp-item.current_page_item").addClass("zp-item-open");

		$("#zp-mobilenav .zp-item.zp-item-has-children > a").on("click", onMobileItemChildClick);
		$("#zp-mobilenav .zp-item:not(.zp-item-has-children) > a").on("click", onMobileItemClick);

		if($html.hasClass("zp-touch")) {
			$("#zp-burger").on("click",onMobileBurgerClick);
			$w.on("scroll", onHeaderOut);
		} else {
			$("#zp-burger").on("click", toggleMobileMenu);
			$header.on("mouseover", onHeaderOver).on("mouseleave", onHeaderOut);
			$menuItems = $topNavInner.find("> .menu > .zp-item");
			$menuItems.on("mouseover", onMenuItemOver);
			$topNavInner.on("mouseleave", onMenuItemOut);
			onMenuItemOut();
		}

		$(".zp-contact-link").on("click", onContact);

		onResize();
		onAosInit();

		setInterval(onRefreshHeight, 1000);
	}

	function onMobileBurgerClick() {
		console.log("test");
		toggleMobileMenu();
		setTimeout(function() {
			onHeaderOver();
		}, 10);
	}

	function onContact(e) {
		e.preventDefault();
		setTimeout(function() {
			var offset = parseInt($("html").attr("data-scroll-offset"));
			var interrupt = true;
			if (w.ZP_TOUCH) {
				interrupt = false;
			}
			$(w).resize();
			$.scrollTo('#zp-contact', {offset: offset, interrupt: interrupt, duration: 1000, easing: "swing"});
		}, 400);

		$('#zp-footer-contact-element-content').collapse('show');
	}

	function onRefreshHeight() {
		var height = document.body.offsetHeight;
		if(height != documentHeight) {
			documentHeight = height;
			footerOffsetTop = $('#zp-contact').offset().top;
			AOS.refresh();
		}
	}

	function onAosInit() {
		AOS.init({
			offset: 200,
			duration: 600,
			easing: 'ease-in-sine',
			delay: 100,
		});
	}

	function onLightboxInit() {
		/**
		$('.lightbox').each(function(index, element){
			var $ele = $(element);
			if(!$ele.hasClass("lightbox-loaded")) {
				var group = $ele.attr("data-lightbox-group");
				if(group) {
					$('.lightbox.' + group).addClass("lightbox-loaded").iLightBox(({
						skin: 'custom',
						mousewheel: false,
						infinite: true,
						smartRecognition: true,
						mobileOptimizer: true,
						innerToolbar: false,
						overlay: {
							blur: true
						},
						controls: {
							controls: false,
							arrows: false,
							slideshow: false,
						}
					}));
				}
			}
		});
		**/
	}

	function onMobileItemClick(e) {
		$html.removeClass("zp-mobile-open");
	}

	function onMobileItemChildClick(e) {
		e.preventDefault();
		var $ele = $(this);
		var $container = $ele.closest(".zp-item");
		if($container.hasClass("zp-item-open")) {
			$container.removeClass("zp-item-open");
		} else {
			$container.addClass("zp-item-open");
		}
	}

	function toggleMobileMenu() {
		if($html.hasClass("zp-mobile-open")) {
			$html.removeClass("zp-mobile-open");
		} else {
			$html.addClass("zp-mobile-open");
		}
	}

	function onLoad() {
		$html.addClass("zp-load");
		AOS.init({
			offset: 200,
			duration: 600,
			easing: 'ease-in-sine',
			delay: 100
		});
	}

	function onResize() {
		w.ZP_WIDTH = $w.width();
		w.ZP_HEIGHT = $w.height();

		footerOffsetTop = $('#zp-contact').offset().top;

		if(w.ZP_WIDTH <= 768) {
			$html.attr("data-scroll-offset", "-100");
		} else {
			$html.attr("data-scroll-offset", "-140");
		}
	}

	function onScroll() {
		w.ZP_SCROLL_TOP = w.scrollY;
		var windowOffsetTop = w.ZP_SCROLL_TOP + w.ZP_HEIGHT;

		if(w.ZP_SCROLL_TOP > 20) {
			html.classList.add("zp-scroll");
		} else {
			html.classList.remove("zp-scroll");
		}

		if(w.ZP_SCROLL_TOP > 300) {
			html.classList.add("zp-sticky");
		} else {
			html.classList.remove("zp-sticky");
		}

		if(windowOffsetTop < footerOffsetTop) {
			html.classList.remove('zp-end');
		} else {
			html.classList.add('zp-end');
		}

		for (var i = 0; i < darkRows.length; ++i) {
			var item = darkRows[i];
			var top = item.offsetTop;
			if(top < w.ZP_SCROLL_TOP + 20 && top + item.offsetHeight > w.ZP_SCROLL_TOP) {
				html.classList.add("zp-scroll-light");
				return false;
			} else {
				html.classList.remove("zp-scroll-light");
			}
		}
	}

	function onHeaderOver() {
		html.classList.add("zp-header-over");
	}

	function onHeaderOut() {
		html.classList.remove("zp-header-over");
	}

	function onMenuItemOver() {
		$menuLine.removeClass("hide");
		var $item = $(this);
		$menuLine.css({"left" : $item.position().left + "px", "width" : $item.width() + "px"});
	}

	function onMenuItemOut() {
		var current = $menuItems.filter(".current-zp-item, .current-zp-ancestor");
		if(current.length > 0) {
			$menuLine.removeClass("hide");
			var $item = $(current.get(0));
			$menuLine.css({"left": $item.position().left + "px", "width": $item.width() + "px"});
		} else {
			$menuLine.addClass("hide");
		}
	}

}(jQuery, document, window));